import { render } from "./IconNormalFolder.vue?vue&type=template&id=7d39f738"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconNormalFolder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d39f738"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d39f738', __exports__)) {
    api.reload('7d39f738', __exports__)
  }
  
  module.hot.accept("./IconNormalFolder.vue?vue&type=template&id=7d39f738", () => {
    api.rerender('7d39f738', render)
  })

}


export default __exports__